import { tv } from "@otomoro/helpers/mergeClasses";
import { VariantProps } from "tailwind-variants";

export const styles = tv({
	slots: {
	  wrapper: 'w-full h-full flex flex-col pt-[7.5rem] px-2',
	  // center the list vertically with auto top & bottom margins
	  list:    'my-auto w-full flex flex-col divide-y-[1.5px] pb-[3.5rem]',
	  listItem:'py-[1.5rem]',
	  button:  'appearance-none flex items-center pt-2',
	  icon:    'rotate-180 w-[1.2rem] mr-[0.6rem]',
	},
  });
  

export type ApplicationsVariants = VariantProps<typeof styles>
